<template>
  <div>
    <a-modal
      v-show="!ishand"
      id="warp_sim12"
      width="40rem"
      v-model="visible"
      on-ok="handleOk1"
      v-dragModal
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{ top: 32 + '%' }"
    >
      <div class="mark-file">
        <div
          style="
            background-color: #0c8b97;
            border-radius: 10px 10px 0 0;
            color: #fff;
            width: 38rem;
            margin: 1rem 1rem 0 1rem;
            text-align: center;
          "
        >
          添加保薦機構
        </div>
      </div>
      <div solt="title" style="position: relative">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div class="content">
        <div>
          <div style="display: flex;align-items: center; margin-bottom: 1rem;" v-for="(item,index) in baojiaList" :key="index">
            <div class="baojia_flex">
              <div style="flex-shrink: 0;font-size: 0.8rem;color: #000;">{{item.name_ch}}：</div>
              <!-- :disabled='ipoAduitAdmin' -->
              <Situationall v-model="item.value_ch"
                :url='$api.getParamList'
                :params='{"type":"baojianr"}'
                :valstr='item.baojianr_enval_ch'
                :style='"width: 100%;"'>
              </Situationall>
            </div>
            <div class="baojia_flex">
              <div style="flex-shrink: 0;font-size: 0.8rem;color: #000;">{{item.name_en}}：</div>
              <Situationall v-model="item.value_en"
                :url='$api.getParamList'
                :params='{"type":"baojianr_en"}'
                :valstr='item.baojianr_enval_en'
                :style='"width: 100%;"'>
              </Situationall>
            </div>
            <img src="../../../image/delete.png" style="width: 18px;cursor: pointer;" @click="deleClick(index)">
          </div>
          <div class="baojia_add" @click="addbaojia()">+</div>
        </div>
        <div style="margin-top: 1.5rem">
          <div @click="saveClick()" class="saveBtn" >確&emsp;認</div>
        </div>
      </div>
      <div style="width: 100%; height: 1px"></div>
    </a-modal>
  </div>
</template>

<script>
import App from "@/assets/app.js";
export default {
  props:["items","baojianr_ch","baojianr_en"],
  data() {
    return {
      ishand: false,
      visible: true,
      userfileAuditAdmin:
        this.$store.state.rolesdata.indexOf("userfileAuditAdmin") >= 0,
				ipoAduitAdmin: this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0,
      baojiaList:[
        {
          name_ch:'保薦機構',
          value_ch:'',
          name_en:'Sponsor',
          value_en:'',
        }
      ]
    };
  },
  mounted() {
    const arr_ch = this.baojianr_ch.split(';');
    const arr_en = this.baojianr_en.split(';');
    console.log(arr_en);
    if (arr_ch.length>0 || arr_en.length>0) {
      this.baojiaList = []
      for (let i = 0; i < arr_ch.length; i++) {
        let addVal={
          name_ch:'保薦機構',
          value_ch:arr_ch[i],
          name_en:'Sponsor',
          value_en:'',
        }
        this.baojiaList.push(addVal)
      }
      for (let i = 0; i < arr_en.length; i++) {
        this.baojiaList[i].value_en = arr_en[i]
      }
      this.baojiaList.forEach(item => {
        item.baojianr_enval_ch = item.value_ch
        item.baojianr_enval_en = item.value_en
      });
    }
  },

  methods: {
    // 添加
    addbaojia(){
      var add = {
        name_ch:'保薦機構',
        value_ch:'',
        name_en:'Sponsor',
        value_en:'',
      }
      this.baojiaList.push(add)
    },
    // 刪除
    deleClick(index){
      this.baojiaList.splice(index, 1);
      console.log(this.baojiaList);
      this.baojiaList.forEach(item => {
        item.baojianr_enval_ch = item.value_ch
        item.baojianr_enval_en = item.value_en
      });
    
    },
    handleCancel(ev) {
      this.$emit("child", 0);
    },

    saveClick() {
      this.$emit("child", this.baojiaList);

    },
  },
};
</script>

<style lang="scss">
@media screen and (min-width: 2200px) {
  .saveBtn {
    font-size: 20px !important;
  }
  .content {
    font-size: 20px !important;
  }
}
#warp_sim12 .ant-modal-header,
#warp_sim12 .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

#warp_sim12 {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-form-explain {
    display: none;
  }

  .ant-modal {
    top: 8%;
  }

  .ant-col-12 {
    text-align: right;
  }
  .myleft {
    text-align: left;
  }
  .ant-form-item-label {
    width: 30%;
  }

  .ant-form-item,
  .ant-form-item-control {
    width: 100%;

    .ant-calendar-picker {
      width: 100%;
    }
  }

  .ant-radio-group-default {
    width: 100%;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 0.8rem;
    }
  }

  .ant-form-item-control-wrapper {
    width: 70%;

    .ant-form-item-control {
      width: 100%;
    }
  }

  #lastname {
    text-align: right;

    .ant-form-item-label {
      width: 10%;
    }

    .ant-form-item-control-wrapper {
      width: 86%;
    }
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 1rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-input {
    font-size: 0.8rem !important;
  }

  .ant-select-selection-selected-value {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
  }

  .btn1 {
    cursor: pointer;
    width: 8rem;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
    margin: 0 3rem;
  }

  .btnx {
    background-color: #0c8b97;
  }

  .btn2 {
    background-color: #ed4849;
  }

  .mydivs {
    max-height: 7rem;
    overflow-y: auto;
    // margin-bottom: 1rem;
    padding: 1rem;
    margin-left: 4%;
    width: 96%;
    background-color: #f5f5f5;
    margin-bottom: 1rem;

    .c {
      font-size: 0.8rem;
    }

    .f {
      // text-align: right;
      display: flex;
      justify-content: space-between;
    }

    .t {
      margin: 0.5rem 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
  .denglu .ant-select{
    width: 9rem;
  }
}
</style>
<style lang="scss" scoped>
.saveBtn{
  width: 25%;
  background: #0c8b97;
  padding: 10px 0;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  font-size: 16px;
  margin: auto;
}
.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 2.5rem 1rem 1.5rem;
  background-color: #fff;
  width: 38rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  min-height: 50px;
  font-size: 16px;
}
.baojia_flex{
  display: flex;
  align-items: center;
  width: 100%;
  margin-right: 1rem;
}
.baojia_add{
  width: 100%;
  background: #F6F7F8;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b0c1c9;
  font-size: 1.5rem;
  margin-top: 1rem;
  cursor: pointer;
}
</style>
